export const tr = {
  common: {
    appName: "eSAĞLIK",
    search: "Ara",
    searchPlaceholder: "Uygulamada ara...",
    favorites: "Favoriler",
    notifications: "Bildirimler",
    noNewNotifications: "Yeni bildirim yok",
    messages: "Mesajlar",
    cart: "Sepet",
    logout: "Çıkış yap",
    session: "Oturum",
    settings: "Ayarlar",
    theme: "Tema",
    language: "Dil",
    inDevelopment: "Geliştirme aşamasında",
    loading: "Yükleniyor...",
    save: "Kaydet",
    cancel: "İptal",
    confirm: "Onayla",
    delete: "Sil",
    edit: "Düzenle",
    close: "Kapat",
    back: "Geri",
    next: "İleri",
    submit: "Gönder",
    activate: "Etkinleştir",
    register: "Kayıt ol",
    apply: "Başvur",
    book: "Rezervasyon",
    pay: "Öde",
    download: "İndir",
    upload: "Yükle",
    share: "Paylaş",
    view: "Görüntüle",
    filter: "Filtrele",
    sortBy: "Sırala",
    all: "Tümü",
    active: "Aktif",
    inactive: "Pasif",
    pending: "Beklemede",
    completed: "Tamamlandı",
    cancelled: "İptal edildi",
    free: "Ücretsiz",
    noData: "Veri yok",
    error: "Hata",
    tenantScopeDenied: "Erişim klinik düzeyinde kısıtlıdır.",
    success: "Başarı",
    required: "Zorunlu",
    optional: "İsteğe bağlı",
    eur: "EUR",
  },
  appointment_created: "Randevu basariyla olusturuldu ve klinik programa eklendi.",
  laboratory_case_created: "Laboratuvar vakasi olusturuldu ve islenmeyi bekliyor.",
  laboratory_results_ready: "Laboratuvar sonuclari klinik inceleme icin hazir.",
  laboratory_case_delivered: "Laboratuvar sonuçları hastaya teslim edildi.",
  payment_success: "Odeme basariyla tamamlandi.",
  LARGE_TRANSACTION: "Dikkat gerektiren büyük bir işlem tespit edildi.",
  service_subscription_activated: "Modül aboneliği etkinleştirildi.",
  service_subscription_expired: "Modül aboneliğinin süresi doldu.",
  inventory_incident_reported: "Bir ekipman olayı bildirildi.",
  business_invoice_created: "Yeni bir B2B faturası oluşturuldu.",
  verification: {
    requestedSuccess: "Talebiniz yoneticiye gonderildi.",
    requirementsMissing: "Dogrulama talep etmek icin dogrulanmis bir klinigin uyesi olmalisiniz.",
  },
  security: {
    setPin: "PIN belirle",
    pinRequired: "Profil duzenlemeyi acmak icin lutfen PIN belirleyin.",
    pinSuccess: "PIN kaydedildi.",
  },
  media: {
    uploading: "Dosya yukleniyor...",
    allowedImageFormat: "Izin verilen format: JPG, PNG",
    uploadSuccess: "Dosya basariyla kaydedildi",
    uploadFile: "Dosya yukle",
    dropOrClick: "Dosyayi buraya tiklayin veya surukleyin",
  },
  showcase: {
    hero: {
      badge: "✦ 1 numarali saglik platformu · Kosova",
      reserve: "Simdi randevu al",
      dotsLabel: "Slayt sec",
      slides: {
        speed: {
          title: "Online doktor randevusu al",
          subtitle: "Uygun saati bulun, doktorunuzu secin ve ziyareti saniyeler icinde onaylayin.",
          button: "Simdi randevu al",
        },
        nearby: {
          title: "Size en yakin uzmanlari bulun",
          subtitle: "Size yakin bakimi bulmak icin sehir, uzmanlik ve mesafeye gore arayin.",
          button: "Uzman bul",
        },
        vault: {
          title: "Tibbi dosyaniz %100 guvende",
          subtitle: "Raporlar, analizler ve klinik gecmisiniz korumali kisisel Vault icinde saklanir.",
          button: "Gecmisimi ac",
        },
      },
    },
  },
  ads: {
    selectOwner: "Odeme sahibini sec",
    selectPriority: "Onceligi sec",
    errorOwnerNotFound: "Odeme hesabi bulunamadi. Listeden gecerli bir sahip secin.",
    requestAd: "Reklam Talep Et",
    platformInternal: "Platform reklami",
    pendingApproval: "Onay bekliyor",
    pendingPayment: "Reklam olusturuldu, fatura odemesi bekleniyor.",
    requestSent: "Talep gonderildi. Incelenmesi icin faturalar bolumunden odeme yapin.",
    waitingApproval: "onay bekliyor",
    marketingTab: "Pazarlama ve Tanitim",
    marketing: "Pazarlama",
    payConfirm: "Bu faturayı Wallet üzerinden ödemek istediğinizden emin misiniz?",
    cancelSuccess: "Talep başarıyla iptal edildi.",
  },
  medimarket: {
    orderCompleted: "Siparis tamamlandi",
    walletPaymentCompleted: "Odeme Wallet uzerinden basariyla tamamlandi.",
    trackingCode: "Takip kodu",
    requiresPrescription: "Tibbi recete gereklidir",
  },
  themes: {
    lightFlat: "Light",
    dark: "Dark",
    gradientLight: "Gradient",
  },
  languages: {
    sq: "SQ",
    en: "EN",
    sr: "SR",
    tr: "TR",
  },
  roles: {
    business: "İşletme",
    doctor: "Doktor",
    specialist: "Uzman",
    technician: "Teknisyen",
    patient: "Hasta",
    admin: "Yönetim",
    superadmin: "Superadmin",
    student: "Öğrenci",
    guest: "Ziyaretçi",
    none: "Aktif profil yok",
  },
  nav: {
    dashboard: "Kontrol Paneli",
    corporateDashboard: "Kurumsal Kontrol Paneli",
    search: "Ara",
    patientHome: "Sayfam",
    professionalPanel: "Panelim",
    appointments: "Randevular",
    monitoring: "İzleme",
    familyCare: "Aile Bakımı",
    clinicalHistory: "Klinik Geçmiş",
    laboratory: "Laboratuvar",
    labResults: "Sonuçlar",
    labAdmin: "Lab Paneli",
    serviceHub: "Hizmet Merkezi",
    inventory: "Envanter",
    jobs: "İş İlanları",
    insurance: "Sigorta",
    events: "Etkinlikler",
    familyDashboard: "Aile Paneli",
    wallet: "Cüzdan",
    businessWallet: "Isletme Cüzdani",
    medimarket: "Medimarket",
    cart: "Sepet",
    seller: "Mağazam",
    registerBusiness: "Isletme Kaydet",
    myBlog: "Blogum",
    adsManagement: "Reklam Yonetimi",
    invoices: "Faturalar",
    messages: "Mesajlar",
    departments: "Departmanlar",
    hospitalBeds: "Yataklar",
    hospitalAdmissions: "Kabuller",
    admin: "Admin",
    verifyDoctors: "Doktor Doğrulama",
    account: "Hesap",
    businesses: "İşletmeler",
    myClinic: "Kliniğim",
    reportTemplate: "Rapor şablonu",
  },
  professionalSettings: {
    tabs: { profile: "Profil", timeline: "Eğitim ve deneyim", skills: "Beceriler ve diller", social: "Sosyal ağlar", weekly: "Haftalık çalışma saatleri", exceptions: "İstisnalar", security: "Güvenlik" },
    status: { publicActive: "Genel CV etkin", publicInactive: "Genel CV etkin değil", verified: "Doğrulandı", pendingVerification: "Doğrulama bekliyor" },
    actions: { viewPublicCv: "Genel CV'yi görüntüle", marketingView: "Pazarlama görünümü" },
  },
  invoices: {
    labels: { status: "Durum" },
    status: { paid: "Ödendi", unpaid: "Ödenmedi", pending: "Beklemede", failed: "Başarısız", cancelled: "İptal edildi" },
    medicalService: "Tıbbi hizmet",
    columns: { patient: "Hasta", service: "Hizmet", amount: "Tutar", status: "Durum", date: "Tarih", actions: "İşlemler" },
    list: { title: "Klinik faturaları", summary: "Toplam {{count}} fatura · {{amount}} EUR tahsil edildi", loadErrorTitle: "Klinik faturaları yüklenemedi", loadErrorDescription: "Bağlantınızı kontrol edip yeniden deneyin.", emptyTitle: "Henüz fatura yok", emptyDescription: "İlk randevu ödemelerinden sonra faturalar burada görünür." },
    actions: { payWithWallet: "Cüzdanla öde", confirmPayment: "Ödemeyi onayla", paying: "Ödeniyor...", cancelRequest: "Talebi iptal et", cancelRequestDescription: "Bu işlem reklam talebini ve ödenmemiş faturayı iptal eder.", cancelling: "İptal ediliyor..." },
    detail: { title: "Fatura ayrıntıları", amount: "Tutar", receivedAmount: "Alınan tutar", paidAmount: "Ödenen tutar", transactionId: "İşlem kimliği", type: "Tür", credit: "Giriş", debit: "Çıkış", description: "Açıklama", reference: "Referans", createdAt: "Oluşturulma tarihi", completedAt: "Tamamlanma tarihi", balanceBefore: "Önceki bakiye", balanceAfter: "Sonraki bakiye", generatingPdf: "Oluşturuluyor...", pdfGenerationFailed: "PDF oluşturulamadı. Lütfen yeniden deneyin.", pdfUnavailable: "PDF yalnızca borç işlemleri için kullanılabilir." },
  },
  modules: {
    connecting: "Bu modül bağlantı aşamasında",
    appointments: "Tıbbi Randevular",
    monitoring: "Sağlık İzleme",
    laboratory: "Laboratuvar",
    insurance: "Sağlık Sigortası",
    events: "Etkinlikler ve Webinarlar",
    jobs: "İstihdam Platformu",
    inventory: "Tıbbi Envanter",
    serviceHub: "Hizmet Merkezi",
    wallet: "Dijital Cüzdan",
    medimarket: "Tıbbi Pazar",
    messages: "Mesajlar",
    clinical: "Klinik Geçmiş",
    family: "Aile Bakımı",
    imaging: "Tıbbi Görüntüleme",
  },
  wallet: {
    cardLink: { title: "Banka kartı", connect: "Kartı bağla", change: "Kartı değiştir", expires: "son kullanma", description: "Hızlı ödemeler ve faturalar için." },
    title: "Dijital Cüzdan",
    eyebrow: "E-Cüzdan",
    financialTitle: "Finansal Cüzdan",
    financialDescription: "Bakiye, analiz ve ödemeler gerçek zamanlı yönetilir.",
    notFoundTitle: "Cüzdan bulunamadı",
    notFoundDescription: "Bakiye şu anda yüklenemiyor. Lütfen biraz sonra tekrar deneyin.",
    balance: "Bakiye",
    topUp: "Bakiye Yükle",
    history: "İşlem geçmişi",
    noTransactions: "İşlem yok",
    credit: "Kredi",
    debit: "Borç",
    completed: "Tamamlandı",
    pending: "Beklemede",
    failed: "Başarısız",
    insufficientFunds: "Cüzdanda yetersiz bakiye.",
    invoicePaid: "Fatura başarıyla ödendi.",
    paymentSuccess: "Ödeme başarıyla tamamlandı.",
    totalBalance: "Toplam bakiye",
    myQrCode: "QR kodum",
    transactions: "Islemler",
    activeSessions: "Etkin oturumlar",
    activeRefs: "Etkin referanslar",
    qrSubtitle: "Hizli transferler icin tarayin",
    qr: { scanHint: "Hızlı transfer için banka veya sağlık uygulamasıyla tarayın." },
  },
  billing: {
    b2bInvoices: "B2B SaaS faturaları",
    vat: "KDV",
    paymentSuccessful: "Ödeme başarıyla tamamlandı.",
  },
  auth: {
    resetEmailSent: "Hesap mevcutsa, talimatları içeren bir email gönderildi.",
    passwordChangedSuccess: "Şifreniz başarıyla değiştirildi. Artık giriş yapabilirsiniz.",
  },
  errors: {
    VERIFIED_PROFILE_REQUIRED: "Hesabınız inceleniyor. Doğrulandıktan sonra paylaşım yapabileceksiniz.",
    INSUFFICIENT_FUNDS: "Bu işlem için Cüzdanınızda yeterli bakiye yok.",
    ACCESS_DENIED: "Bu bölüme erişim yetkiniz yok.",
    ALREADY_EXISTS: "Bu bilgi sistemde zaten mevcut.",
    NOT_FOUND: "İstenen kaynak bulunamadı.",
    generic: "Bir hata oluştu. Lütfen tekrar deneyin.",
    network: "Bağlantı sorunu. İnternet bağlantınızı kontrol edin.",
    unauthorized: "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
    notFound: "Sayfa bulunamadı.",
    insufficientFunds: "Cüzdanda yetersiz bakiye.",
    forbidden: "Bu işlem için yetkiniz yok.",
    invalidFileType: "Yuklenen dosya gecerli bir gorsel veya video degil.",
    reportNotFound: "Tibbi rapor bulunamadi.",
    REPORT_REQUIRED_FIELDS_MISSING: "Imzalamadan once zorunlu alanlari doldurun.",
    fieldLocked: "Kilitli alan silinemez.",
    clinicalAccessDenied: "Erisim reddedildi: bu bolum gizli klinik veriler icerir.",
    retentionPolicyActive: "Tamamlanmis tibbi raporlar yasal saklama suresi nedeniyle silinemez.",
    retention_policy_active: "Tamamlanmis tibbi raporlar yasal saklama suresi nedeniyle silinemez.",
    hospitalMetadataRequired: "Hastane raporu kabul bilgileri olmadan imzalanamaz.",
    bedAlreadyOccupied: "Yatak zaten dolu.",
    invalidResetToken: "Bu bağlantı geçersiz veya süresi dolmuş.",
  },

  pages: {
    lab:       { eyebrow: 'Laboratuvar',             title: 'Analiz Sonuçları',         description: 'Sistem tarafından hesaplanan durumlarla en son klinik veriler.' },
    events:    { eyebrow: 'Tıbbi Platform',          title: 'Etkinlikler ve Webinarlar', description: 'Canlı ve kaydedilmiş tıbbi webinarlar, konferanslar ve eğitimler.' },
    jobs:      { eyebrow: 'Tıbbi Platform',          title: 'İş İlanları',              description: 'Sağlık sektöründe istihdam ve kariyer fırsatları.' },
    insurance: { eyebrow: 'Sağlık Sigortası',        title: 'Sigorta Portalı',          description: 'Kosova sigorta ortaklarından sağlık poliçeniz ve kapsamınız.' },
    wallet:    { eyebrow: 'Dijital Cüzdan',          title: 'Cüzdan',                   description: 'Bakiyenizi, işlemlerinizi ve tıbbi ödemelerinizi yönetin.' },
    favorites: { eyebrow: 'Favoriler',               title: 'Favorilerim',              description: 'Kaydettiğiniz doktorlar, klinikler ve ürünler.' },
    inventory: { eyebrow: 'Tıbbi Varlıklar',         title: 'Akıllı Envanter',          description: 'QR ve yaşam döngüsü takibi ile tıbbi ekipman yönetimi.' },
    serviceHub:{ eyebrow: 'Hizmet Merkezi',          title: 'Service Hub',              description: 'Kliniğiniz için platform modüllerini etkinleştirin ve yönetin.' },
    monitoring:{ eyebrow: 'Sağlık İzleme',           title: 'İzleme',                   description: 'Gerçek zamanlı sağlık parametresi takibi ve ölçümü.' },
  },

  posts: {
    patientQuestion: "Hasta sorusu",
    professionalPost: "Profesyonel gönderi",
    summaryLabel: "Kısa özet",
    officialBadge: "Resmi makale",
    patientBadge: "Hasta sorusu",
    rejectionReason: "Reddetme nedeni",
    unverifiedAlert: "Gönderiniz onay bekliyor",
    commentRestricted: "Profesyonel gönderilere yalnızca sağlık personeli yorum yapabilir.",
    rejectionTitle: "Reddedildi",
    status: {
      published: "Yayinda",
      pending: "Onay bekliyor",
      rejected: "Reddedildi",
      draft: "Taslak",
      scheduled: "Planlandi",
      expiring: "Suresi doluyor",
      expired: "Suresi doldu",
    },
    rejectionFallback: "Yayınlanmadan önce gönderinin düzeltilmesi gerekiyor.",
    moderation: {
      title: "Gönderi moderasyonu",
      description: "Gönderiler burada inceleme bekler ve yalnızca onaylandıktan sonra Showcase'te görünür.",
      empty: "İnceleme bekleyen gönderi yok.",
      archiveEmpty: "Onaylanmış veya reddedilmiş gönderi yok.",
      untitled: "Başlıksız",
      approvePublish: "Onayla ve yayınla",
      reject: "Reddet",
      rejectTitle: "Gönderiyi reddet",
      rejectDescription: "Yazara gösterilecek nedeni seçin. Reddetmek gönderiyi silmez.",
      extraNote: "Yazara ek not",
      rejectWithReason: "Nedeniyle reddet",
      tabs: { pending: "Beklemede", archive: "Aktif" },
      reasons: {
        inaccurate: "Yanlış bilgi",
        unethical: "Etik olmayan içerik",
        promotional: "İzin verilmeyen promosyon içeriği",
      },
    },
  },

  access: {
    unauthorized_role: "Bu rolün hastanın klinik dosyasına erişimi yok.",
    relationship_required: "Klinik ilişki veya hastadan aktif izin gerekir.",
    requestNewGrant: "Yeni erişim izni iste",
    clinicalForbidden: {
      title: "Erişim engellendi",
      description: "Bu bölüm özel klinik veriler içerir.",
    },
    moduleInactive: {
      title: "Modül henüz etkinleştirilmedi",
      description: "Backend bu modülü şu anda etkin değil olarak bildiriyor.",
    },
    profileRequired: {
      title: "Etkin bir profil seçin",
      description: "Bu bölüm, backend'in oturumunuz için bildirdiği profil bağlamına bağlıdır.",
    },
    permissionMissing: {
      title: "Gerekli izin eksik",
      description: "Bu bölüm şunları gerektirir: {{permissions}}. Yöneticiyle iletişime geçin.",
    },
    denied: {
      title: 'Izole Bölüm',
      description: 'Bu, izole bir {{role}} bölümür. Bu bağlam için yetkiniz yok.',
    },
    clinicalIsolation: {
      title: 'Klinik Erişim Engellendi',
      description: 'Yöneticiler klinik verilere erişemez (Anayasa §III). Rolünüz: {{role}}.',
    },
    notVerified: 'Profiliniz henüz bir yönetici tarafından doğrulanmamıştır.',
    technicianBlock: 'Gizlilik Koruması: Bu bölüm (Ajanda/Workbench) yalnızca uzman sağlık personeli için ayrılmıştır.',
    pendingVerification: 'Doğrulama Bekleniyor',
    switchBusiness: 'İş Moduna Geç',
    switchClinical: 'Klinik Moduna Dön',
    businessMode: 'İş Modu',
    clinicalMode: 'Klinik Modu',
  },
  admin: {
    title: "Kontrol merkezi",
    auditTrail: "Denetim kaydı",
    allDomains: "Tüm alanlar",
    allSeverities: "Tüm önem düzeyleri",
    recentEvents: "son etkinlikler",
    noEvents: "Kayıtlı etkinlik yok.",
    growth: { title: "Yeni hesaplar - son 7 gün", noData: "Son 7 günde kayıt yok.", newAccounts: "Yeni hesaplar" },
    kpi: { totalAccounts: "Toplam hesap", activeAccounts: "sistemdeki etkin hesaplar", appointments: "Randevular (ay)", appointmentsSub: "tamamlanan randevular", volume: "Finansal hacim", volumeSub: "aylık işlemler" },
  },
  superadmin: {
    verifyBusiness: "Doğrula",
    moduleApprovals: "Modül onayları",
    activateModule: "Modülü etkinleştir",
  },
  business: {
    licenseUsage: "Lisans kullanımı",
    doctorLimit: "Doktor limiti",
    usedSeats: "Kullanılan lisanslar",
  },
  appointments: {
    title: "Tıbbi randevular",
    book: "Randevu al",
    upcoming: "Yaklaşan randevular",
    past: "Geçmiş randevular",
    confirmed: "Onaylandı",
    requested: "Talep gönderildi",
    completed: "Tamamlandı",
    cancelled: "İptal edildi",
    noAppointments: "Planlanmış randevu yok",
    selectDoctor: "Doktoru seçin",
    selectDate: "Tarihi seçin",
    selectTime: "Saati seçin",
    confirmPayment: "Onayla ve cüzdanla öde",
    insufficientFunds: "Yetersiz bakiye",
    addFunds: "Bakiye ekle ->",
    patientList: { eyebrow: "Hasta randevuları", title: "Rezervasyonlar ve ödemeler", createPatient: "Hasta oluştur", total: "Toplam", totalDescription: "Hesabınıza kayıtlı randevular.", confirmed: "Onaylandı", confirmedDescription: "Ödenmiş ve onaylanmış rezervasyonlar.", pending: "Beklemede", pendingDescription: "Ödeme bekleyen rezervasyonlar.", historyTitle: "Randevu geçmişi", historyDescription: "Her rezervasyonun durumu, zamanı ve ödemesi.", emptyTitle: "Henüz randevu yok", emptyDescription: "İlk randevunuz burada görünecek.", doctorBusiness: "Doktor #{{doctorId}} · İşletme #{{businessId}}", service: "Hizmet #{{serviceId}}", openWorkbench: "Workbench'i aç", starts: "Başlangıç", ends: "Bitiş", invoice: "Fatura", noInvoice: "Henüz fatura yok" },
    confirmation: { stepTitle: "Adım 4 · Onay", stepDescription: "Rezervasyon, cüzdan ödemesi tamamlandıktan sonra kesinleşir.", clinic: "Klinik", service: "Hizmet", doctor: "Doktor", specialization: "Uzmanlık", date: "Tarih", time: "Saat", price: "Fiyat", selectClinic: "Klinik seçin", selectService: "Hizmet seçin", selectSlot: "Saat seçin", willAppear: "Görüntülenecek", walletNotice: "Cüzdan ödemesi yalnızca onaydan sonra tamamlanır. Bakiye, backend yeni değeri döndürene kadar değişmez.", referenceOptional: "Referans (isteğe bağlı)", referencePlaceholder: "örn. kardiyoloji kontrolü", insufficientFundsDescription: "Cüzdanda yeterli bakiye yok.", warning: "Dikkat", lowBalance: "Bakiye ({{balance}}), {{amount}} için yeterli olmayabilir." },
  },
  search: {
    title: "Akıllı arama",
    placeholder: "Doktor, klinik veya uzmanlık arayın...",
    placeholderShort: "Doktor, klinik ara...",
    verified: "Doğrulandı",
    viewProfile: "Profili görüntüle",
    publicProfile: "Genel profil etkin",
    noResults: "Sonuç bulunamadı.",
    filters: "Filtreler",
    advancedFilters: "Gelişmiş filtreler",
    radius: "Yarıçap (km)",
    gender: "Cinsiyet",
    any: "Herhangi biri",
    female: "Kadın",
    male: "Erkek",
    tabs: { all: "Tümü", professionals: "Doktorlar", clinics: "Klinikler" },
    cities: { all: "Tüm şehirler", prishtina: "Priştine", prizren: "Prizren", gjilan: "Gilan", peja: "İpek", mitrovica: "Mitroviça" },
  },
  messagesPage: {
    eyebrow: "Güvenli MSN",
    title: "Mesajlar",
    description: "Yalnızca klinik bağlamla açılan özel hasta-profesyonel görüşmeleri.",
    reconnecting: "Bağlantı kesildi. Yeniden deneme {{current}}/{{max}}...",
    failedReconnect: "Bağlantı 5 denemeden sonra başarısız oldu. Sayfayı yenileyin.",
  },
  events: {
    title: "Etkinlikler ve web seminerleri",
    register: "Kaydol",
    registered: "Kaydoldunuz",
    registering: "Kaydediliyor...",
    full: "Kontenjan dolu.",
    free: "Ücretsiz",
    online: "Çevrim içi",
    inPerson: "Yüz yüze",
    hybrid: "Hibrit",
    webinar: "Web semineri",
    conference: "Konferans",
    training: "Eğitim",
    workshop: "Atölye",
    seminar: "Seminer",
    noEvents: "Etkin etkinlik yok",
  },
  jobs: {
    title: "İstihdam platformu",
    apply: "Başvur",
    applying: "Başvuruluyor...",
    applied: "Başvuruldu",
    fullTime: "Tam zamanlı",
    partTime: "Yarı zamanlı",
    contract: "Sözleşme",
    onSite: "Yerinde",
    remote: "Uzaktan",
    hybrid: "Hibrit",
    salary: "Maaş",
    noOffers: "Etkin ilan yok",
  },
};

